import { reportCustomError } from '@utils/owlReporter';

const detect = () => {
    try {
        if (navigator.userAgent.match(/^waimai_e_pc_client/)) {
            // 确认在壳子里
            // 检查一下 window.wmSystemApi
            if (!window.wmSystemApi) {
                // 这时候看一下 global 上有没有相关属性
                // @ts-ignore
                const globalHasWmSystemApi = !!global.wmSystemApi;
                // @ts-ignore
                const globalHasWmPrinterApi = !!global.wmPrinterApi;
                // @ts-ignore
                const globalHasWmNetworkApi = !!global.wmNetworkApi;
                const windowHasWmSystemApi = !!window.wmSystemApi;
                const windowHasWmPrinterApi = !!window.wmPrinterApi;
                const windowHasWmNetworkApi = !!window.wmNetworkApi;

                reportCustomError({
                    name: `wmSystemApi丢失`,
                    message: `wmSystemApi丢失`,
                    category: 'wmSystemApi丢失',
                    tags: {
                        globalHasWmSystemApi,
                        globalHasWmPrinterApi,
                        globalHasWmNetworkApi,
                        windowHasWmSystemApi,
                        windowHasWmPrinterApi,
                        windowHasWmNetworkApi,
                    },
                    level: 'WARN',
                });
            }
        }
    } catch (e) {
        // 这里有情况
        reportCustomError({
            name: `wmSystemApi丢失检查异常`,
            message: e.messae,
            category: 'wmSystemApi丢失检查异常',
            level: 'WARN',
        });
    }
};

export default {
    detect,
};
